import axios from "../axios";

export function submitOnboarding({ onboardingConfigs, envDomain }) {
    return axios.post(`onboard`, { onboardingConfigs, envDomain }).then(({ data }) => data);
}
